module.exports = __webpack_public_path__ + "img/9.740e0137.png";